import { useSearchStateSync } from '../hooks';
import {
  ComboboxProvider,
  ListBox,
  ListBoxEmpty,
  ListBoxItem,
  Popover,
  Trigger,
  useCombobox
} from '../modules/combobox';
import { TextEditor, TextEditorProvider } from '../modules/text-editor';

const SearchBarContent = () => {
  const { state, triggerRef } = useCombobox();

  useSearchStateSync();

  return (
    <>
      <Trigger ref={triggerRef}>
        <TextEditor />
      </Trigger>

      <Popover
        isNonModal
        isOpen={state.isOpen}
        offset={4}
        triggerRef={triggerRef}
      >
        <ListBox
          items={state.collection}
          renderEmptyState={() => <ListBoxEmpty>No results found</ListBoxEmpty>}
          selectedKeys={
            state.selectionManager.focusedKey
              ? [state.selectionManager.focusedKey]
              : []
          }
        >
          {item => (
            <ListBoxItem id={item.key} textValue={item.textValue}>
              {item.textValue}
            </ListBoxItem>
          )}
        </ListBox>
      </Popover>
    </>
  );
};

export const SearchBar = () => {
  return (
    <ComboboxProvider>
      <TextEditorProvider>
        <SearchBarContent />
      </TextEditorProvider>
    </ComboboxProvider>
  );
};
